import { OrganizationKeyName } from "../../../model/Organization";
import { httpClient } from "../../../service/http";
import {
  Integration,
  IntegrationListItem,
  IntegrationPayload,
  IntegrationProvider,
  IntegrationSuccessResponse,
} from "../models/integrations";
import {
  DeletePayload,
  PostPayload,
  PutPayload,
} from "../../../model/http-crud-models";

export const integrationsHttp = {
  getIntegrations: async (
    organizationKeyName: OrganizationKeyName
  ): Promise<IntegrationListItem[]> => {
    const url = `/organizations/${organizationKeyName}/integrations/items`;

    const res = await httpClient<IntegrationSuccessResponse>({
      method: "GET",
      url,
    });

    return res.data;
  },

  getIntegration: async (
    organizationKeyName: OrganizationKeyName,
    id?: string
  ): Promise<Integration> => {
    const url = `/organizations/${organizationKeyName}/integrations/items/${id}`;

    const res = await httpClient<Integration>({
      method: "GET",
      url,
    });

    return res;
  },

  getIntegrationProviders: async (
    organizationKeyName?: OrganizationKeyName
  ): Promise<IntegrationProvider[]> => {
    const url = `/organizations/${organizationKeyName}/integrations/providers`;
    const res = await httpClient<{ data: IntegrationProvider[] }>({
      method: "GET",
      url,
    });

    return res.data;
  },

  createIntegration: async ({
    organizationKeyName,
    data,
  }: PostPayload<IntegrationPayload>): Promise<string> => {
    const url = `/organizations/${organizationKeyName}/integrations/items`;
    const res = await httpClient<{ id: string }>({
      method: "POST",
      url,
      data,
    });

    return res.id;
  },

  updateIntegration: async ({
    organizationKeyName,
    data,
  }: PutPayload<IntegrationPayload>) => {
    const { id, ...rest } = data;
    return httpClient({
      method: "PUT",
      url: `/organizations/${organizationKeyName}/integrations/items/${id}`,
      data: rest,
    });
  },

  deleteIntegration: async ({
    data: { id },
    organizationKeyName,
  }: DeletePayload) => {
    const url = `/organizations/${organizationKeyName}/integrations/items/${id}`;

    return httpClient({
      method: "DELETE",
      url,
    });
  },
};
